<script setup>
  import {
    onMounted,
    ref,
  } from 'vue'

  import Image from '@components/Image.vue'

  import { useI18n } from '@shared/i18n.js'
  import { useAjax } from '@composables/useAjax.js'
  import { generateUrl } from '@shared/util.js'

  defineProps({
    classList: {
      default: "blog_list",
      type: String
    },
  })

  const articles = ref(null)

  const indexPath = generateUrl('blog', '')

  const { t } = useI18n()
  const { callGet } = useAjax()

  onMounted(async () => {
    const response = await callGet(window.app.common.sideBarBlogsPath)
    if (response.articles && response.articles.length > 0) {
      Promise.allSettled(response.articles.map((article) => callGet(article.path)))
        .then((results) => articles.value = results.filter((result) => result.status == 'fulfilled').map((result) => result.value.article))
    }
  })
</script>

<template>
  <div v-if="articles" class="blog_side">
    <h2><i class="fa-solid fa-tag"></i>{{ t('c.japan_blog') }}</h2>
    <div :class="classList">
      <div v-for="(article, index) in articles" :key="`side-article-${index}`" class="item">
        <a :href="article.path">
          <div class="photo">
            <Image :image="article.thumbnail" />
          </div>
          <h3 class="item_text">{{ article.title }}</h3>
        </a>
      </div>
    </div>
    <p class="blog_side_more">
      <a :href="indexPath">{{ t('c.read_more') }}</a>
    </p>
  </div>
</template>
